import React from 'react';

export const EMPTY_USER_FILTER = Object.freeze({
  email: '',
  firstName: '',
  lastName: '',
  username: '',
});

const USER_FILTER_FIELDS = Object.keys(EMPTY_USER_FILTER);

export const getUserFilterFromSearchParams = (searchParams) =>
  USER_FILTER_FIELDS.reduce((nextFilter, field) => {
    nextFilter[field] = searchParams.get(field) ?? '';
    return nextFilter;
  }, {});

export const getUserFilterSearchParams = (filter = {}) =>
  USER_FILTER_FIELDS.reduce((nextParams, field) => {
    const rawValue = filter[field];
    const value = typeof rawValue === 'string' ? rawValue.trim() : '';

    if (value) {
      nextParams[field] = value;
    }

    return nextParams;
  }, {});

const UserSearchBar = ({ filter, onFilterChange, onSubmit, submitLabel = 'Apply Filter' }) => (
  <form className="filter-bar" onSubmit={onSubmit}>
    <input
      type="text"
      name="email"
      placeholder="Email"
      value={filter.email}
      onChange={onFilterChange}
    />
    <input
      type="text"
      name="firstName"
      placeholder="First Name"
      value={filter.firstName}
      onChange={onFilterChange}
    />
    <input
      type="text"
      name="lastName"
      placeholder="Last Name"
      value={filter.lastName}
      onChange={onFilterChange}
    />
    <input
      type="text"
      name="username"
      placeholder="Username"
      value={filter.username}
      onChange={onFilterChange}
    />
    <button type="submit">{submitLabel}</button>
  </form>
);

export default UserSearchBar;
